import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox, SimpleHint, Text, useResponsive, WarningIcon } from '@common-fe/common-fe';

interface Props {
  id?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  isLiquidationMode?: boolean;
  testId?: string;
}

const LiquidationCheckbox: React.FC<Props> = ({
  id,
  testId,
  value,
  onChange,
  disabled,
  isLiquidationMode,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  return (
    <Box direction="row">
      {isLiquidationMode && (
        <SimpleHint
          content={<Text>{t('Your request exceeds 95% of the portfolio. All holdings will be sold.')}</Text>}
        >
          <Box margin={isMobile ? { right: 'spacing4' } : { left: 'xs' }}>
            <WarningIcon color="warning" />
          </Box>
        </SimpleHint>
      )}
      <Checkbox
        name={id || ''}
        testId={testId}
        checked={isLiquidationMode || value}
        onChange={onChange}
        disabled={disabled || isLiquidationMode}
      >
        {isMobile ? (
          <Text color="textSecondary" size="small" weight={500} margin={{ left: '-4px' }}>
            {t('Liquidate position')}
          </Text>
        ) : undefined}
      </Checkbox>
    </Box>
  );
};

export default LiquidationCheckbox;
